(function () {
  'use strict';

  const SELECTORS = {
    rows:    '[data-drawer-tab]',
    overlay: '#pdpDrawerOverlay',
    drawer:  '#pdpDrawer',
    close:   '#pdpDrawerClose',
    tabs:    '.pdp-drawer__tab',
    panels:  '.pdp-drawer__panel',
    title:   '#pdpDrawerTitle',
  };

  function getTitles() {
    return window.pdpDrawerTitles || ['Description', 'Free Delivery', 'Discreet Packaging', 'Notre engagement', 'Ingrédients'];
  }

  let startY = 0;

  function openDrawer(tabIndex) {
    const drawer  = document.querySelector(SELECTORS.drawer);
    const overlay = document.querySelector(SELECTORS.overlay);
    if (!drawer || !overlay) return;

    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-active');
    document.body.classList.add('pdp-drawer-open');

    switchTab(tabIndex);
  }

  function closeDrawer() {
    const drawer  = document.querySelector(SELECTORS.drawer);
    const overlay = document.querySelector(SELECTORS.overlay);
    if (!drawer || !overlay) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-active');
    document.body.classList.remove('pdp-drawer-open');
  }

  function switchTab(index) {
    const title = document.querySelector(SELECTORS.title);
    if (title) title.textContent = getTitles()[index] || '';

    document.querySelectorAll(SELECTORS.tabs).forEach((btn) => {
      const active = parseInt(btn.getAttribute('data-tab'), 10) === index;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    document.querySelectorAll(SELECTORS.panels).forEach((panel) => {
      const active = panel.id === 'pdpPanel' + index;
      panel.classList.toggle('is-active', active);
    });
  }

  function bindEvents() {
    document.querySelectorAll(SELECTORS.rows).forEach((row) => {
      row.addEventListener('click', () => {
        const tabIndex = parseInt(row.getAttribute('data-drawer-tab'), 10) || 0;
        openDrawer(tabIndex);
      });
    });

    const overlay = document.querySelector(SELECTORS.overlay);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    const closeBtn = document.querySelector(SELECTORS.close);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

    document.querySelectorAll(SELECTORS.tabs).forEach((btn) => {
      btn.addEventListener('click', () => {
        const index = parseInt(btn.getAttribute('data-tab'), 10) || 0;
        switchTab(index);
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeDrawer();
    });

    const drawer = document.querySelector(SELECTORS.drawer);
    if (drawer) {
      drawer.addEventListener('touchstart', (e) => {
        startY = e.touches[0].clientY;
      }, { passive: true });

      drawer.addEventListener('touchend', (e) => {
        const endY = e.changedTouches[0].clientY;
        if (endY - startY > 80) closeDrawer();
      }, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindEvents);
  } else {
    bindEvents();
  }

  /* =====================
     VARIANT META UPDATE
  ===================== */
function richTextToHtml(obj) {
  if (!obj) return '';
  if (typeof obj === 'string') {
    return obj.replace(/\n/g, '<br>');
  }
  if (obj.type === 'root') return obj.children.map(richTextToHtml).join('');
  if (obj.type === 'paragraph') return '<p>' + obj.children.map(richTextToHtml).join('') + '</p>';
  if (obj.type === 'heading') return '<h' + obj.level + '>' + obj.children.map(richTextToHtml).join('') + '</h' + obj.level + '>';
  if (obj.type === 'list') return '<ul>' + obj.children.map(richTextToHtml).join('') + '</ul>';
  if (obj.type === 'list-item') return '<li>' + obj.children.map(richTextToHtml).join('') + '</li>';
  if (obj.type === 'text') {
    let text = obj.value || '';
    if (obj.bold) text = '<strong>' + text + '</strong>';
    if (obj.italic) text = '<em>' + text + '</em>';
    return text;
  }
  if (obj.children) return obj.children.map(richTextToHtml).join('');
  return '';
}

document.addEventListener('change', function (e) {
  const input = e.target.closest('input[type="radio"][data-variant-id]');
  if (!input) return;

  const variantId = input.getAttribute('data-variant-id');
  const meta = window.pdpVariantMeta;
  if (!meta || !variantId || !meta[variantId]) return;

  const data = meta[variantId];

  const descHtml           = data.description || window.pdpDefaultDescription || '';
  const ingredientsHtml    = data.ingredients || '';
  const nosEngagementsHtml = data.nos_engagements || '';

  const descEl                = document.getElementById('pdpVariantDesc');
  const descTabInfo           = document.getElementById('pdpVariantDescTab');
  const descTabBtn            = document.getElementById('pdpVariantDescTabBtn');
  const ingredientEl          = document.getElementById('pdpVariantIngredient');
  const ingredientTabInfo     = document.getElementById('pdpVariantIngredientTab');
  const ingredientTabBtn      = document.getElementById('pdpVariantIngredientTabBtn');
  const nosEngagementsEl      = document.getElementById('pdpVariantNosEngagements');
  const nosEngagementsTabInfo = document.getElementById('pdpVariantNosEngagementsTab');
  const nosEngagementsTabBtn  = document.getElementById('pdpVariantNosEngagementsTabBtn');

  if (descEl)        descEl.innerHTML              = descHtml;
  if (descTabInfo)   descTabInfo.style.display     = descHtml ? '' : 'none';
  if (descTabBtn)    descTabBtn.style.display      = descHtml ? '' : 'none';

  if (ingredientEl)      ingredientEl.innerHTML          = ingredientsHtml;
  if (ingredientTabInfo) ingredientTabInfo.style.display = ingredientsHtml ? '' : 'none';
  if (ingredientTabBtn)  ingredientTabBtn.style.display  = ingredientsHtml ? '' : 'none';

  if (nosEngagementsEl)       nosEngagementsEl.innerHTML           = nosEngagementsHtml;
  if (nosEngagementsTabInfo)  nosEngagementsTabInfo.style.display  = nosEngagementsHtml ? '' : 'none';
  if (nosEngagementsTabBtn)   nosEngagementsTabBtn.style.display   = nosEngagementsHtml ? '' : 'none';
});
})();